export interface DigitalArtifact {
  id: string;
  code: string;
  title: string;
  type: string;
  description: string;
  behavior: string;
  color: string;
}

export interface ExperienceNode {
  id: string;
  label: string;
  code: string;
  x: number;
  y: number;
  description: string;
  system: string;
}

export const digitalArtifacts: DigitalArtifact[] = [
  {
    id: 'signal',
    code: 'OBJ-01',
    title: 'Esfera de señal',
    type: 'Identidad reactiva',
    description: 'Una superficie sensible que convierte movimiento, ritmo y proximidad en una presencia de marca reconocible.',
    behavior: 'Distorsión / puntero / pulso',
    color: '#d8ff3e',
  },
  {
    id: 'prism',
    code: 'OBJ-02',
    title: 'Prisma de decisión',
    type: 'Conversión espacial',
    description: 'Capas de información que se ordenan alrededor de una decisión sin perder profundidad ni clima.',
    behavior: 'Rotación / capas / foco',
    color: '#6de2ff',
  },
  {
    id: 'catalog',
    code: 'OBJ-03',
    title: 'Matriz de catálogo',
    type: 'Exploración modular',
    description: 'Una grilla que deja de ser inventario y se transforma en un campo visual para descubrir relaciones.',
    behavior: 'Grilla / expansión / filtro',
    color: '#a88cff',
  },
  {
    id: 'portal',
    code: 'OBJ-04',
    title: 'Portal de lanzamiento',
    type: 'Entrada cinemática',
    description: 'Un umbral digital que administra expectativa, revela contenido y marca el comienzo de una campaña.',
    behavior: 'Profundidad / órbita / reveal',
    color: '#ff6b3d',
  },
  {
    id: 'network',
    code: 'OBJ-05',
    title: 'Arquitectura viva',
    type: 'Sistema conectado',
    description: 'Nodos, reservas, consultas y datos representados como una estructura que responde en tiempo real.',
    behavior: 'Nodos / flujo / estado',
    color: '#f0ede4',
  },
];

export const experienceNodes: ExperienceNode[] = [
  { id: 'launch', label: 'Lanzamiento', code: 'LX-01', x: 18, y: 20, description: 'Ritmo, expectativa y una secuencia de revelación diseñada como campaña.', system: 'Micrositio / cuenta regresiva / contenido por etapas' },
  { id: 'catalog', label: 'Catálogo', code: 'CT-02', x: 70, y: 15, description: 'Productos conectados por gesto, contexto, colección y afinidad visual.', system: 'Filtros / combinaciones / consulta contextual' },
  { id: 'booking', label: 'Reservas', code: 'RV-03', x: 84, y: 48, description: 'Una decisión compleja convertida en un recorrido breve, claro y táctil.', system: 'Agenda / sedes / profesionales / confirmación' },
  { id: 'three', label: 'Experiencia 3D', code: '3D-04', x: 68, y: 79, description: 'Objetos y espacios que se pueden recorrer antes de existir físicamente.', system: 'WebGL / cámara / materiales / interacción' },
  { id: 'event', label: 'Evento', code: 'EV-05', x: 25, y: 82, description: 'Una capa digital que extiende la energía del evento antes, durante y después.', system: 'Invitación / acceso / agenda / activación' },
  { id: 'product', label: 'Producto premium', code: 'PR-06', x: 8, y: 52, description: 'El producto tratado como protagonista: detalle, materia, escala y deseo.', system: 'Reveal / variantes / narrativa / consulta' },
  { id: 'brand', label: 'Marca institucional', code: 'BR-07', x: 45, y: 34, description: 'Una presencia editorial que expresa criterio antes de explicar servicios.', system: 'Posicionamiento / casos / cultura / contacto' },
  { id: 'automation', label: 'Automatización', code: 'AU-08', x: 48, y: 67, description: 'Flujos invisibles representados de forma comprensible y operable.', system: 'Reglas / estados / handoff / dashboard' },
];

export const livingInterfaces = [
  {
    id: 'booking',
    code: 'UI-01',
    title: 'Reserva en tres gestos',
    description: 'Disponibilidad, selección y confirmación sin abandonar el clima visual.',
  },
  {
    id: 'product',
    code: 'UI-02',
    title: 'Producto en escena',
    description: 'Una ficha que revela materia, variantes y detalle con profundidad.',
  },
  {
    id: 'dashboard',
    code: 'UI-03',
    title: 'Datos que respiran',
    description: 'Un tablero mínimo donde el movimiento explica estado y tendencia.',
  },
  {
    id: 'launch',
    code: 'UI-04',
    title: 'Lanzamiento latente',
    description: 'Cuenta regresiva, acceso y expectativa dentro de una interfaz compacta.',
  },
];
